import React from "react";
import Modal from "../Modal/Modal";
import "../MissedAlertsModal/MissedAlertsModal.css";
import "./DeepInsightsPromptLibraryModal.css";
import { useConstants } from "../../constant/constantProvider";

export const PROMPT_CATEGORIES = [
  {
    title: "Market Intel",
    prompts: [
      "What external signals are impacting LATAM this week?",
      "Currencies at risk this quarter?",
      "Top 3 macro signals for Europe agri."
    ]
  },
  {
    title: "Competitor Intel",
    prompts: [
      "Which are the competitor selling Mancozeb.",
      "Competitor launches affecting our portfolio.",
      "Competitor Market Share for UPL Brands."
    ]
  },
  {
    title: "COGS of COGS",
    prompts: [
      "Impact of crude at 120 on Acephate.",
      "10% EDC cost increase on Mancozeb.",
      "Sulphur to Mancozeb cost transmission."
    ]
  },
  {
    title: "Regulatory Pulse",
    prompts: [
      "Canada PMRA triazole impact.",
      "Competitor patents expiry watch.",
      "Latest EU regulation changes."
    ]
  }
];

const DeepInsightsPromptLibraryModal = ({ open, onClose, onSelect }) => {
  const { PROMPT_LIBRARY_TITLE, PROMPT_LIBRARY_DESC } = useConstants();

  return (
    <Modal open={open} onClose={onClose} className="di-missed-alerts-modal-wrapper">
      <div className="di-missed-alerts-modal-content">
        <div className="di-missed-alerts-modal-header">
          <div className="di-missed-alerts-modal-title">
            <h3>{PROMPT_LIBRARY_TITLE}</h3>
            <p>{PROMPT_LIBRARY_DESC}</p>
          </div>
          <button className="di-missed-alerts-modal-close" onClick={onClose}>
            &times;
          </button>
        </div>
        <div className="di-missed-alerts-modal-body thin-scroll">
          <div className="di-prompt-library-grid">
            {PROMPT_CATEGORIES.map((category, index) => (
              <div key={index} className="di-prompt-category-card">
                <h4 className="di-prompt-category-title">{category.title}</h4>
                <div className="di-prompt-list">
                  {category.prompts.map((prompt, pIndex) => (
                    <button 
                      key={pIndex} 
                      className="di-prompt-item"
                      onClick={() => onSelect(prompt)}
                    >
                      {prompt}
                    </button>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default DeepInsightsPromptLibraryModal;
